<template>
	<div>
		<div class="row">
			<div class="col-md-8">
				<div class="panel">
					<div class="panel-heading">
						{{ map.title }}
					</div>
					<div class="panel-body">
						<gmap-map
							:class="map.class"
							ref="gmapMap"
							:center="map.center"
							:zoom="map.zoom"
							map-type-id="roadmap"
							style="width: 100%; height: 500px">

							<gmap-info-window
								v-if="infoContent"
								:options="infoOptions"
								:position="infoWindowPos"
								:opened="infoWinOpen"
								@closeclick="infoWinOpen=false">
								<div class="gmap-info-window">
									<div v-if="infoContent.user">
										<h3>
											<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/users/' + infoContent.user.id">
												{{ infoContent.user.profile.first_name }} {{ infoContent.user.profile.middle_name }} {{ infoContent.user.profile.last_name }}
											</router-link>
										</h3>
										<p>
											<a :href="'mailto:' + infoContent.user.email">{{ infoContent.user.email }}</a>
										</p>
										<span v-if="!infoContent.user.profile.available">
											<h5>
												<label class="label label-warning">
													No disponible
												</label>
											</h5>
											<h5>
												{{ dateUnavailable(infoContent.user.profile.unavailable) }}
											</h5>
										</span>
										<span v-else>
											<h5>
												<label class="label label-success">
													Disponible
												</label>
											</h5>
										</span>
										<span v-if="infoContent.user.profile.place">
											<p>
												{{ infoContent.user.profile.place.formatted_address }}
											</p>
										</span>
										<hr>
										<span class="pull-right">
											<span v-if="infoContent.user.profile.mobile">
												<a :href="'tel:' + infoContent.user.profile.mobile" :title="$t('interface.actions.call') + ' ' + infoContent.user.profile.mobile" class="btn btn-info btn-outline btn-circle m-r-5">
													<i class="fa fa-mobile" aria-hidden="true"></i>
												</a>
											</span>
											<span v-if="infoContent.user.profile.phone">
												<a :href="'tel:' + infoContent.user.profile.phone" :title="$t('interface.actions.call') + ' ' + infoContent.user.profile.phone" class="btn btn-info btn-outline btn-circle m-r-5">
													<i class="fa fa-phone-square" aria-hidden="true"></i>
												</a>
											</span>
											<span>
												<button @click="$refs.taskCreate.open(project, infoContent.user, search.place)" :title="$tc('interface.new', 1) | ucfirst" class="btn btn-success btn-outline btn-circle m-r-5">
													<i aria-hidden="true" class="fa fa-plus"></i>
												</button>
											</span>
										</span>
									</div>
									<div v-else>
										<span v-if="infoContent.place">
											<p>
												{{ infoContent.place.formatted_address }}
											</p>
										</span>
									</div>
								</div>
							</gmap-info-window>

							<gmap-cluster ref="gmapCluster">
								<gmap-marker
									v-for="(marker,id) in map.markers"
									:icon="marker.icon"
									:key="marker.id"
									:label="marker.label"
									:position="marker.position"
									:clickable="true"
									:draggable="false"
									@click="toggleInfoWindow(marker,id)">
								</gmap-marker>
							</gmap-cluster>
						</gmap-map>
					</div>
				</div>
			</div>

			<div class="col-md-4">
				<div class="panel">
					<div class="panel-heading">
						Proyectos
					</div>
					<div class="panel-body">
						<div>
							<ul class="nav nav-tabs" role="tablist">
								<li role="presentation" class="active">
									<a href="#projects" aria-controls="projects" role="tab" data-toggle="tab" title="Proyectos">
										Proyectos
									</a>
								</li>
								<li role="presentation">
									<a href="#search" aria-controls="search" role="tab" data-toggle="tab" title="Buscador">
										Buscador
									</a>
								</li>
							</ul>

							<div class="tab-content">
								<div role="tabpanel" class="tab-pane active" id="projects">
									<div v-if="statuses">
										<ul v-if="statuses.length" class="nav nav-tabs" role="tablist">
											<li v-for="(status, index) in statuses" role="presentation" :class="{ 'active' : status.projects.length }">
												<a :href="'#' + status.slug" :aria-controls="status.slug" role="tab" data-toggle="tab" :title="status.name">
													<span :class="'label label-' + status.class" v-html="status.icon"></span>
													<label>
														{{ status.projects.length }}
													</label>
												</a>
											</li>
										</ul>

										<div v-if="statuses.length" class="tab-content">
											<div v-for="(status, index) in statuses" role="tabpanel" class="tab-pane" :id="status.slug" :class="{ 'active' : status.projects.length }">
												<div v-if="status.projects">
													<h5 v-if="status.projects.length" v-for="_project in status.projects">
														<input type="radio" v-model="project" v-bind:value="_project"> {{ _project.name }}
													</h5>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div role="tabpanel" class="tab-pane" id="search">
									<div class="input-group">
										<gmap-autocomplete
											id="gmapAutocomplete"
											ref="gmapAutocomplete"
											class="form-control"
											@place_changed="setPlace">
										</gmap-autocomplete>
										<span class="input-group-btn">
											<button @click="fitBounds" class="btn btn-default" type="button">
												<i class="fa fa-window-maximize" aria-hidden="true"></i>
											</button>
										</span>
									</div>
									<div v-if="search.place">
										<hr>
										<div v-if="map.markers">
											<table v-if="map.markers.length" class="table table-hover table-striped table-condensed">
												<tbody>
													<tr v-for="marker in map.markers" v-if="marker.destination">
														<td @click="viewMarker(marker)" class="link">
															<span>
																<img v-if="marker.infoText.user.profile.avatar" :src="marker.infoText.user.profile.avatar" :alt="marker.infoText.user.email" class="img-responsive img-circle" width="30">
																<i v-else class="fa fa-user-circle-o" aria-hidden="true" :title="marker.infoText.user.email"></i>
																
																{{ marker.infoText.user.email }}
															</span>
														</td>
														<td>
															<label class="label label-default">
																<i class="fa fa-car" aria-hidden="true"></i>
																{{ marker.destination.distance.text }}
															</label>
														</td>
														<td>
															<label class="label label-default">
																<i class="fa fa-clock-o" aria-hidden="true"></i>
																{{ marker.destination.duration.text }}
															</label>
														</td>
														<td>
															<span v-if="marker.infoText.user.profile.mobile">
																<a :href="'tel:' + marker.infoText.user.profile.mobile" :title="$t('interface.actions.call') + ' ' + marker.infoText.user.profile.mobile" class="btn btn-info btn-outline btn-circle m-r-5">
																	<i class="fa fa-mobile" aria-hidden="true"></i>
																</a>
															</span>
															<span v-if="marker.infoText.user.profile.phone">
																<a :href="'tel:' + marker.infoText.user.profile.phone" :title="$t('interface.actions.call') + ' ' + marker.infoText.user.profile.phone" class="btn btn-info btn-outline btn-circle m-r-5">
																	<i class="fa fa-phone-square" aria-hidden="true"></i>
																</a>
															</span>
															<span>
																<button @click="$refs.taskCreate.open(project, marker.infoText.user, search.place)" :title="$tc('interface.new', 1) | ucfirst" class="btn btn-success btn-outline btn-circle m-r-5">
																	<i aria-hidden="true" class="fa fa-plus"></i>
																</button>
															</span>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<task-create
			v-if="user.hasRole(['manager', 'admin'])"
			ref="taskCreate"
			@changePlace="changePlace"
			@openCreateSchedule="openCreateSchedule"
			:place="search.place"
			:user="user"
			:isAuth="isAuth">
		</task-create>

		<schedule-create
			:place="search.place"
			v-if="user.hasRole(['manager', 'admin'])"
			ref="scheduleCreate"
			:user="user"
			:isAuth="isAuth">
		</schedule-create>
	</div>
</template>

<script>
import TaskCreate from '../../tasks/views/Create.vue'
import ScheduleCreate from '../../schedules/views/Create.vue'
export default {
	props: ['user', 'isAuth'],
	components: {
		'task-create': TaskCreate,
		'schedule-create': ScheduleCreate,
	},
	data () {
		return {
			search: {
				place: null,
				marker: null,
			},
			statuses: null,
			project: null,
			map: {
				visible: false,
				class: 'locked',
				title: 'Mapa',
				center: {
					lat: 0,
					lng: 0,
				},
				zoom: 10,
				markers: [],
			},
			infoContent: '',
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -25
				}
			},
		}
	},
	watch: {
		project: function () {
			this.search.marker = null
			this.search.place = null
			this.infoWinOpen = false
			var users = null
			if(this.project.team) {
				if(this.project.team.users) {
					if(this.project.team.users.length) {
						users = this.project.team.users
					}
				}
			}

			if(users) {
				this.loadMarkers(users)
				this.map.class = ''
				this.map.title = 'Mapa de ' + this.project.team.name
			} else {
				this.clearMarkers()
				this.map.class = 'locked'
				this.map.title = 'Mapa (sin equipo)'
			}
		},
		'map.zoom'() {
			this.reZoom(this.map.zoom)
		}
	},
	mounted() {
		this.centerMap()
	},
	created() {
		this.init()
	},
	methods: {
		init() {
			this.getProjects()
		},
		loadMarkers(users) {
			this.clearMarkers()
			if(users.length) {
				var map = this.$refs.gmapMap.$mapObject
				var that = this
				users.forEach(function(element, key) {
					if(element.profile.place) {
						if(element.profile.place.lat && element.profile.place.lng) {
							var marker = {
								id: key,
								position: {
									lat: parseFloat(element.profile.place.lat),
									lng: parseFloat(element.profile.place.lng),
								},
								infoText: { user: element},
							}

							var overlay = that.setMarker(marker)
							marker.overlay = overlay
							that.map.markers.push(marker)
						}
					}
				})
				if(this.map.markers.length) {
					this.$set(this.map, 'markers', this.map.markers)
					this.fitBounds()
					this.$refs.gmapCluster.$clusterObject.setMap(map)
				}
			}
		},
		toggleInfoWindow (marker, idx) {
			this.infoWindowPos = marker.position;
			this.infoContent = marker.infoText;
			//check if its the same marker that was selected if yes toggle
			if (this.currentMidx == idx) {
				this.infoWinOpen = !this.infoWinOpen;
			}
			//if different marker set infowindow to open and reset current marker index
			else {
				this.infoWinOpen = true;
				this.currentMidx = idx;
			}
		},
		fitBounds() {
			this.infoWinOpen = false
			if(this.map.markers.length) {
				var b = new google.maps.LatLngBounds()
				this.map.markers.forEach(function(element) {
					b.extend({
						lat: element.position.lat,
						lng: element.position.lng,
					});
				})
				this.$refs.gmapMap.fitBounds(b)
				if(this.map.markers.length < 1) {
					this.map.zoom = 12
				}
			}
		},
		setMarker(marker) {
			var Marker = this.marker()
			var map = this.$refs.gmapMap.$mapObject
			var myLatlng = new google.maps.LatLng(marker.position.lat, marker.position.lng)
			var overlay = new Marker(
				myLatlng,
				map,
				{
					marker: marker,
				}
			)
			overlay.onRemove = function(){
				this.div.remove()
			}
			return overlay
		},
		marker(marker) {
			var CustomMarker = function(latlng, map, args) {
				this.latlng = latlng
				this.args = args
				this.setMap(map)
			}

			CustomMarker.prototype = new google.maps.OverlayView();

			var that = this

			CustomMarker.prototype.draw = function() {
				var self = this;
				
				var div = this.div;

				if(!div) {
					div = this.div = document.createElement('div');
					
					div.id = 'marker';
					div.style.width = '50px';
					div.style.height = '50px';
					if(self.args.marker.infoText.user.profile.available == 1) {
						div.className = 'marker-available';
					} else {
						div.className = 'marker-unavailable';
					}
					
					div.dataset.marker_id = self.args.marker.id;

					var img = document.createElement('img');
					if(self.args.marker.infoText.user.profile.avatar) {
						img.src = self.args.marker.infoText.user.profile.avatar;
						if(self.args.marker.infoText.user.profile.available == 1) {
							img.className = 'marker-avatar profile-available img-responsive';
						} else {
							img.className = 'marker-avatar profile-unavailable img-responsive';
						}
						div.appendChild(img)
					} else {
						img.src = that.$env.ROOT + '/img/no-profile-pic.jpg';
						if(self.args.marker.infoText.user.profile.available == 1) {
							img.className = 'marker-avatar profile-available img-responsive';
						} else {
							img.className = 'marker-avatar profile-unavailable img-responsive';
						}
						div.appendChild(img)
					}
					var panes = this.getPanes();
					panes.overlayImage.appendChild(div);
				}
				
				var point = this.getProjection().fromLatLngToDivPixel(this.latlng);
				
				if (point) {
					div.style.left = (point.x - 25) + 'px';
					div.style.top = (point.y - 50) + 'px';
				}
			}
			return CustomMarker
		},
		getProjects() {
			this.$http.get('admin/projects/projects/statuses/projects')
			.then(response => {
				this.statuses = response.body
				if(this.statuses.length) {
					for(var i = 0; i < this.statuses.length; i++) {
						if(this.statuses[i].projects) {
							if(this.statuses[i].projects.length) {
								this.project = this.statuses[i].projects[0]
								break
							}
						}
					}
				}
			})
		},
		clearMarkers() {
			if(this.$refs.gmapCluster.$clusterObject) {
				this.$refs.gmapCluster.$clusterObject.setMap(null)
			}
			if(this.map.markers.length) {
				this.map.markers.forEach(function(element) {
					if(element.overlay) {
						element.overlay.setMap(null)
					}
				})
				this.map.markers = []
				this.centerMap()
				this.reZoom()
			}
			if(this.search.place) {
				this.setPlace(this.search.place)
			}
		},
		centerMap() {
			if(this.$platform.place) {
				this.map.center.lat = parseFloat(this.$platform.place.lat)
				this.map.center.lng = parseFloat(this.$platform.place.lng)
			}
			this.$refs.gmapMap.panTo(this.map.center)
		},
		reZoom() {
			this.$refs.gmapMap.$mapObject.setZoom(this.map.zoom)
		},
		// SCHEDULES
			openCreateSchedule: function(item) {
				this.$refs.scheduleCreate.item = item
				this.$refs.scheduleCreate.open()
			},
		dateUnavailable (unavailable) {
			if(unavailable.length) {
				for (var i = 0; i < unavailable.length; i++) {
					var element = unavailable[i]
					var start = moment(element.start_date)
					var end = moment(element.end_date)
					if(moment().isBetween(start, end)) {
						return start.format('DD/MM/YYYY - H:mm') + ' | ' + end.format('DD/MM/YYYY - H:mm')
					}
				}
			}
		},
		setPlace(place) {
			this.removePlace()
			if(place.formatted_address) {
				$('#gmapAutocomplete').val(place.formatted_address)
				this.search.place = place
				this.search.marker = {
					isSearch: true,
					id: place.place_id,
					position: {
						lat: place.geometry.location.lat(),
						lng: place.geometry.location.lng(),
					},
					infoText: { place: place },
				}

				this.map.markers.push(this.search.marker)
				this.fitBounds()
				this.map.class = ''
				this.getDistances()
			}
		},
		removePlace() {
			if(this.search.marker) {
				let index = this.map.markers.indexOf(this.search.marker)
				this.map.markers.splice(index)
			}
		},
		getDistances() {
			var that = this
			if(this.map.markers.length) {
				this.map.markers.forEach(function(marker) {
					if(!marker.isSearch) {
						that.getDistanceMatrix(marker)
					}
				})
			}
		},
		getDistanceMatrix(marker) {
			var that = this
			var map = this.$refs.gmapMap.$mapObject
			var service = new google.maps.DistanceMatrixService()
			var origins = this.search.place.geometry.location

			var latitude = marker.position.lat
			var longitude = marker.position.lng
			var destination = new google.maps.LatLng(latitude, longitude)

			service.getDistanceMatrix({
				origins: [origins],
				destinations: [destination],
				travelMode: 'DRIVING',
				},
				function(response, status) {
					if(response.rows.length) {
						if(response.rows[0].elements.length) {
							var element = response.rows[0].elements[0]
							var matrix = {
								distance: element.distance,
								duration: element.duration,
								distanceKm: that.getKm(origins, destination)
							}
							that.$set(marker, 'destination', matrix)
						}
					}
					that.orderMarkers()
				}
			)
		},
		getKm(origins, destination) {
			var metres = google.maps.geometry.spherical.computeDistanceBetween(origins, destination)
			if(metres) {
				var km = metres / 1000
				return km.toFixed(2) + ' km'
			}
		},
		orderMarkers() {
			var compare = function compare(a,b) {
				if(a.destination && b.destination) {
					if (a.destination.distance.value < b.destination.distance.value)
						return -1;
					if (a.destination.distance.value > b.destination.distance.value)
						return 1;
				}
				return 0;
			}
			this.map.markers.sort(compare)
		},
		viewMarker(marker) {
			this.infoWinOpen = false
			this.map.center.lat = parseFloat(marker.position.lat)
			this.map.center.lng = parseFloat(marker.position.lng)
			this.$refs.gmapMap.panTo(this.map.center)
			this.$refs.gmapMap.$mapObject.setZoom(99)
		},
		changePlace(place) {
			this.setPlace(place)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/projects/maps/views/Index.vue